import { useUserReviews } from '@/scopes/products/user-reviews/hooks'
import { tk, Typography } from '@sunwebgroup/ui-components'
import React from 'react'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  margin-bottom: ${tk('spacing_xl')};
`

export function Heading() {
  const intl = useIntl()
  const { reviewsAmount } = useUserReviews()

  return (
    <Wrapper>
      <Typography $variant="heading-xl">
        {intl.formatMessage({ id: 'reviews_amount_heading' }, { amount: reviewsAmount })}
      </Typography>
    </Wrapper>
  )
}
